// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"FavoritesPage_pageWrap__3EINN"};